import { memo } from 'react';
import { Container, Stack, styled } from '@mui/material';
import Typography from '../../atoms/Typography';

const StyledStack = styled(Stack)`
  padding-top: 5rem;
`;

export const makeDataTestId = (dataTestId = 'center-screen') => {
  return {
    prefix: dataTestId,
    wrapper: `${dataTestId}.wrapper`,
    title: `${dataTestId}.title`,
    text: `${dataTestId}.text`,
  };
};

export interface CenterScreenProps {
  topIcon?: React.ReactNode;
  title: React.ReactNode;
  text?: React.ReactNode;
  dataTestId?: string;
  children?: React.ReactNode;
}

const CenterScreen: React.FC<CenterScreenProps> = memo(
  ({ title, text, dataTestId, topIcon, children }: CenterScreenProps) => (
    <Container maxWidth="md">
      <StyledStack alignContent="center" alignItems="center" gap={2} data-testid={makeDataTestId(dataTestId).wrapper}>
        {topIcon}
        <Typography variant="subtitle1" data-testid={makeDataTestId(dataTestId).title} pt={2}>
          {title}
        </Typography>
        {text && (
          <Typography variant="body1" data-testid={makeDataTestId(dataTestId).text}>
            {text}
          </Typography>
        )}
        {children}
      </StyledStack>
    </Container>
  ),
);

export default CenterScreen;
